import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TdropdownItems } from './dropdown.types';

@Component({
  selector: 'monorepo-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent<T> {
  @Input() items!: TdropdownItems<T>;
  @Input() title!: string;

  constructor(public popoverController: PopoverController) {}

  itemSelection($event: Event, itemType: T) {
    this.popoverController.dismiss(itemType);
  }
}
